import { PortableTextListItemComponent } from '@portabletext/react'
import classNames from 'classnames'
import React from 'react'
import { factBoxParagraphClassName } from '../../../FactBox'

export const FactboxListItemSerializer: PortableTextListItemComponent = ({
  children,
  value,
}) => {
  const className =
    value?.listItem === 'number'
      ? classNames(factBoxParagraphClassName, 'min-h-45 pl-60', 'sm:min-h-60 sm:pl-75')
      : 'bullet-item'

  return <li className={className}>{children}</li>
}
